import React from 'react'
import { FormControl, FormErrorMessage, FormLabel, HStack, Input } from '@chakra-ui/react'


type UserFullNameInputProps = {
  register: any;
  errors: any;
}
export const UserFullNameInput: React.FC<UserFullNameInputProps> = ({register, errors}) => {
  return (
    <HStack w='100%'>
      <FormControl isRequired isInvalid={!!errors.user?.last_name}>
        <FormLabel>性</FormLabel>
          <Input placeholder="山田" type="input" {...register('user.last_name')} />
        <FormErrorMessage>{errors.user?.last_name?.message}</FormErrorMessage>
      </FormControl>
      <FormControl isRequired isInvalid={!!errors.user?.first_name}>
        <FormLabel>名</FormLabel>
          <Input placeholder="太郎" type="input" {...register('user.first_name')} />
        <FormErrorMessage>{errors.user?.first_name?.message}</FormErrorMessage>
      </FormControl>
    </HStack>
  );
};